import React, { useState } from 'react';
import Popup from "../imagepopup";


function ScotiaBank() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };


  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p11.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                Worked on the development of Scotiabank's Online Banking platform for Mexico, Caribbean, and Panama, utilizing front-end technologies to create a responsive, secure, and seamless online banking experience. The project focused on modernizing the digital experience, streamlining online banking features, and ensuring the platform was tailored to the specific needs of each region.
                </p>
                <p className="mt-15">
                Utilized HTML, CSS, JavaScript, and responsive frameworks to build and optimize the user interface, ensuring it was accessible across different devices, including mobile and desktop. Integrated regional banking features and localized language support to meet market-specific demands and regulatory requirements.
                </p>
                <p className="mt-15">
                Contributed to the development of Scotiabank’s Wealth Management Application using Pega, focusing on automating workflows, managing customer portfolios, and streamlining financial planning processes. The platform improved the efficiency of wealth management services by leveraging Pega Case Management, Decisioning, and UI components to enhance the customer experience.
                  </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>

                  <p>As a <strong>UI/UX Lead & Front-End Developer</strong>, I was responsible for:</p>
                 
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">UI Design & Development: Built intuitive, responsive interfaces using HTML5, CSS3, JavaScript, and frameworks to deliver a consistent online banking experience across multiple regions.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Cross-Device Compatibility: Ensured the platform’s compatibility and responsiveness across mobile, tablet, and desktop devices, enhancing user experience.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Localization & Customization: Implemented regional customizations for each market (Mexico, Caribbean, Panama), ensuring language support and compliance with local banking regulations.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Performance Optimization: Optimized the front-end performance, improving loading times and overall user interactions.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Collaboration with Backend Teams: Worked with back-end developers to integrate APIs and ensure smooth data flow for customer accounts, transactions, and other banking functionalities. 
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Pega UI Customization: Led the development of custom UI components, dynamic layouts, and skin rules within Pega to optimize the wealth management user interface. 
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Wealth Management Workflow Automation: Implemented Pega Case Management to automate financial planning and portfolio management processes, improving operational efficiency and reducing manual intervention.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Cross-Functional Collaboration: Worked closely with business analysts, developers, and stakeholders to ensure the application met the functional and regulatory requirements for wealth management.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      UI/UX Optimization: Enhanced user experience by focusing on accessibility, responsiveness, and user-friendly navigation.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      API Integration: Integrated REST APIs for real-time financial data and portfolio updates.
                      </h6>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>December 2017</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Lead & Front-End Developer</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>Scotiabank</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p1.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p1.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p7.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p7.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p9.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p9.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p22.jpg" alt=""  onClick={() => handleImageClick("/assets/imgs/works/p22.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/cibc">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/bombardier">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
                              
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default ScotiaBank;
